<template>
  <div>
    <div @click="openDialog">{{ placeholder }}</div>
    <v-dialog width="700" v-model="dialog">
      <v-card>
        <v-card-title>{{
          $t("lang.inbound.dashboard.select_date")
        }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                {{ $t("lang.inbound.dashboard.start_date") }}
                <v-date-picker
                  :allowed-dates="allowedDatesStart"
                  v-model="item.date_start"
                ></v-date-picker>
              </v-col>
              <v-col>
                {{ $t("lang.inbound.dashboard.end_date") }}
                <v-date-picker
                  :allowed-dates="allowedDatesEnd"
                  v-model="item.date_end"
                ></v-date-picker>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn @click="closeDialog" color="primary">
            {{ $t("lang.inbound.dashboard.btn_done") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    name: String,
    placeholder: String,
    onSearch: () => {},
    format: {
      type: [String, Function],
      default: "dd MMM yyyy"
    }
  },
  data() {
    return {
      dialog: false,
      item: {
        date_start: "",
        date_end: ""
      }
    };
  },
  mounted() {
    const startOfMonth = moment()
      .subtract(30, "days")
      .startOf("day")
      .format("YYYY-MM-DD 00:00:00");
    const currentDate = moment()
      .endOf("day")
      .format("YYYY-MM-DD 23:59:59");
    this.item.date_start = startOfMonth;
    this.item.date_end = currentDate;
  },
  methods: {
    allowedDatesStart(val) {
      var date = moment(val).format("YYYY-MM-DD HH:mm:ss");
      var endDate = moment(this.item.date_end).format("YYYY-MM-DD 23:59:59");
      var now = moment().format("YYYY-MM-DD HH:mm:ss");
      return now > date && date < endDate;
    },

    allowedDatesEnd(val) {
      var date = moment(val).format("YYYY-MM-DD HH:mm:ss");
      var startDate = moment(this.item.date_start).format(
        "YYYY-MM-DD 00:00:00"
      );
      var now = moment().format("YYYY-MM-DD HH:mm:ss");

      return now > date && date > startDate;
    },

    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      if (this.item.date_start === this.item.date_end) {
        this.item.date_start = moment(this.item.date_start).format(
          "YYYY-MM-DD 00:00:00"
        );
        this.item.date_end = moment(this.item.date_end).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      this.dialog = false;
      this.$emit("input", this.item);
      this.$emit("onChange");
    }
  }
};
</script>
